import { styled } from '@clickcease/cc-client-components-lib'

export const MainMenuStyled = styled('div', {
  boxShadow: '5px 0px 30px rgba(102, 102, 102, 0.08)',
  borderRadius: '12px',
  width: '218px',
  background: '#FFFFFF',
  padding: '24px 0px 20px 0px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '$r',
  justifyContent: 'space-between',

  '@bp1': {
    borderRadius: '0px',
    width: '100%',
    position: 'fixed',
    height: '100%',
    margin: '0px',
    padding: '0px',
    zIndex: '10',
    ['> svg']: {
      width: '32px',
      height: '31px',
    },
  },
  variants: {
    collapsed: {
      true: {
        width: '59px',
      },
    },
  },
})

export const MenuCells = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  '@bp1': {
    alignItems: 'flex-start',
  },
})

export const MainCellStyled = styled('button', {
  all: 'unset',
  display: 'flex',
  padding: '12px 0px',
  borderRadius: '4px',
  lineHeight: '15px',
  background: '#FFFFFF',
  width: '194px',
  color: '$textColor',
  cursor: 'pointer',
  alignItems: 'center',

  '> svg': {
    marginLeft: '14px',
  },

  '@bp1': {
    width: '96%',
    padding: '0px',
    margin: '10px 0px',

    '> svg': {
      margin: '12px 0px 0px 20px',
    },
  },

  variants: {
    isActive: {
      true: {
        background: '$tableHovered',
        color: '$primaryColor',
        '@bp1': {
          justifyContent: 'flex-start',
        },
      },
    },
    collapsed: {
      true: {
        width: '40px',
        flexDirection: 'column',
        padding: '$4 $2',
        justifyContent: 'center',
        alignItems: 'center',
        ['> svg']: {
          width: '19px',
          height: '19px',
          margin: '0px',
        },
      },
    },
  },

  ['&:hover']: {
    color: '$buttonHovered',
  },

  '&:disabled': {
    color: '$lightNeutral',
    cursor: 'not-allowed',
  },
})

export const MainCellTextStyled = styled('span', {
  fontWeight: '$l',
  fontSize: '$md',
  width: '194px',
  marginLeft: '8px',
  lineHeight: '21px',

  '@bp1': {
    marginLeft: '2px',
    lineHeight: '44px',
  },

  variants: {
    collapsed: {
      true: {
        width: '47px',
        flexDirection: 'column',
        fontSize: '$xs',
        fontWeight: '$rb',
        marginLeft: '0px',
        textAlign: 'center',
        alignItems: 'center',
      },
    },
  },
})

export const MenuSeparator = styled('div', {
  width: '178px',
  height: '0.5px',
  background: '#CACACA',
  display: 'flex',
  margin: '$10 auto',
  '@bp1': {
    width: '92%',
    margin: '10px 4%',
  },

  variants: {
    collapsed: {
      true: {
        width: '32px',
        margin: '19px 20px',
      },
    },
  },
})

export const TopPart = styled('div', {
  width: '218px',
  variants: {
    collapsed: {
      true: {
        width: '57px',
      },
    },
  },
  '@bp1': {
    width: '100%',
  },
})
export const BottomPart = styled(TopPart, {
  bottom: '0',
})

export const LogoWrapper = styled('div', {
  margin: '6px 37px 40px 24px',
  display: 'flex',
  justifyContent: 'space-around',
  width: '157px',
  height: '41px',
  cursor: 'pointer',
  ['> svg']: {
    width: '100%',
    height: '100%',
  },
  '@bp1': {
    width: '100%',
    margin: '0px',
    justifyContent: 'start',
    height: '50px',
    ['> svg']: {
      width: '33px',
      height: '33px',
    },
  },
  variants: {
    collapsed: {
      true: {
        margin: '7px 0 30px 0px',
        width: '57px',

        ['> svg']: {
          width: '32px',
          height: '32px',
        },
      },
    },
  },
})

export const MainMenuButton = styled('button', {
  all: 'unset',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '$16',
  borderRadius: '4px',
  paddingBlock: '$2',
  '&:hover': {
    cursor: 'pointer',
    background: '$tableHovered',
  },
})

export const ClickCeaseSuite = styled('div', {
  fontFamily: 'Open Sans',
  fontWeight: 400,
  color: '$primaryColor',
})

export const ToggleMenuButton = styled('div', {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  margin: '0px $10',
  justifyContent: 'left',

  ['> svg']: {
    cursor: 'pointer',
    width: '14px',
    height: '14px',
  },
  variants: {
    collapsed: {
      true: {
        margin: '0',
        justifyContent: 'center',
      },
    },
  },
})
